export default "__VITE_ASSET__B3R4FslX__"